// vxe-table 全局默认配置集中在这里维护，入口文件只负责注册。
export function getVxeTableConfig() {
  return {
    grid: {
      align: 'center' as const,
      checkboxConfig: {
        reserve: true,
        showReserveStatus: true,
      },
      columnConfig: {
        resizable: false,
      },
      formConfig: {
        // 全局禁用 vxe-table 的表单配置，统一使用 formOptions。
        enabled: false,
      },
      highlightCurrentRow: true,
      minHeight: 100,
      pagerConfig: {
        enabled: true,
        pageSize: 20,
        pageSizes: [5, 10, 20, 30, 50],
      },
      proxyConfig: {
        autoLoad: true,
        enabled: true,
        // 统一约定后端分页列表字段，业务页面有特殊字段时仍可局部覆盖。
        response: {
          list: 'list',
          result: 'list',
          total: 'total',
        },
        showActiveMsg: true,
        showResponseMsg: true,
      },
      round: true,
      rowConfig: {
        isHover: true,
        keyField: 'id',
      },
      showFooter: false,
      showOverflow: false,
      size: 'small' as const,
      virtualYConfig: {
        // 默认关闭纵向虚拟滚动，由具体业务页面按需要单独开启。
        enabled: false,
        // 重要，必须设置，否则滑动闪烁。
        mode: 'scroll' as const,
      },
    },
  }
}
